import * as React from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type { SectionName } from 'bundles/expression-of-interest/components/EoiDialog';
import type { ActionTypes } from 'bundles/expression-of-interest/types';

export type DegreeDescriptionEoiStateContextType = {
  hasCompletedEoi: boolean;
  setHasCompletedEoi: Dispatch<SetStateAction<boolean>>;
  shouldBypassEOIModal: boolean;
  eoiButtonsToUse: ActionTypes[];
  initialSection?: SectionName;
  setInitialSection: Dispatch<SetStateAction<SectionName | undefined>>;
};

export const DegreeDescriptionEoiStateContext = React.createContext<DegreeDescriptionEoiStateContextType | undefined>(
  undefined
);

export const useDegreeDescriptionEoiStateContext = () => {
  const context = React.useContext(DegreeDescriptionEoiStateContext);
  if (!context)
    throw new Error('useDegreeDescriptionEoiStateContext was used outside of DegreeDescriptionEoiStateContext');
  return context;
};

export default DegreeDescriptionEoiStateContext;
